import React, { useEffect, useState } from "react";
import StepsList from "../../components/Driver/StepsList";
import UserHeader from "../../components/Driver/UserHeader";
import { useNavigate } from "react-router-dom";
import API from "../../config/config";

// Main UserDashboard container
const UserDashboard = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  const steps = [
    { key: "profilePhoto", label: "Profile Photo", link: "/upload-profile" },
    {
      key: "drivingLicense",
      label: "Driving License Verification",
      link: "/verify-license",
    },
    {
      key: "aadharCard",
      label: "Aadhar Card Verification",
      link: "/verify-aadhar",
    },
    { key: "panCard", label: "PAN Card Verification", link: "/verify-pan" },
    // { key: "bank", label: "Bank Account Verification", link: "/verify-bank" },
    {
      key: "drivingChoices",
      label: "Driving Choices",
      link: "/driving-choices",
    },
    // { key: "drivingVideos", label: "Driving Videos", link: "/driving-videos" },
  ];

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const token = localStorage.getItem("userPublicToken");
        const res = await fetch(API.ADMIN.USERDASHBOARD, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        // Check for expired/invalid token
        if (res.status === 401 || res.status === 403) {
          localStorage.removeItem("userPublicToken");
          return navigate("/request-otp"); // Adjust path as per your route
        }
        if (!res.ok) throw new Error("Failed to fetch profile");
        const data = await res.json();
        if (data.success) {
          setProfile(data.data);
        } else {
          throw new Error(data.message || "Error fetching profile");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchProfile();
  }, []);
  console.log("profile", profile);
  const getStatusFromProfile = (profile) => ({
    profilePhoto: profile.profileImage ? "Completed" : "Upload",

    drivingLicense:
      profile.drivingLincenseDetails?.DLVerified === "Verified"
        ? "Completed"
        : profile.drivingLincenseDetails?.DLVerified === "Rejected"
        ? "Reupload"
        : profile.drivingLincenseDetails?.DLVerified === "Pending" ||
          profile.drivingLincenseDetails?.DLVerified === "InProgress"
        ? "In Review"
        : "Upload",

    aadharCard:
      profile.aadhaarDetails?.aadharVerified === "Verified"
        ? "Completed"
        : profile.aadhaarDetails?.aadharVerified === "Rejected"
        ? "Reupload"
        : profile.aadhaarDetails?.aadharVerified === "Pending" ||
          profile.aadhaarDetails?.aadharVerified === "InProgress"
        ? "In Review"
        : "Upload",

    panCard:
      profile.panDetails?.panVerified === "Verified"
        ? "Completed"
        : profile.panDetails?.panVerified === "Rejected"
        ? "Reupload"
        : profile.panDetails?.panVerified === "Pending" ||
          profile.panDetails?.panVerified === "InProgress"
        ? "In Review"
        : "Upload",
    bank:
      profile.bankAccountDetails?.status === "Verified"
        ? "Completed"
        : profile.bankAccountDetails?.status === "Rejected"
        ? "Reupload"
        : profile.bankAccountDetails?.status === "Pending" ||
          profile.bankAccountDetails?.status === "InProgress"
        ? "In Review"
        : "Upload",
    drivingChoices: profile.drivingChoices ? "Completed" : "Upload",

    drivingVideos: profile.trainingVerified ? "Completed" : "Upload",
  });

  const handleLogout = () => {
    // Example logout: clear token and reload or redirect
    localStorage.removeItem("userPublicToken");
    window.location.reload();
  };

  if (loading)
    return (
      <div className="h-screen flex items-center justify-center bg-white">
        <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-indigo-600"></div>
      </div>
    );
  if (error) return <div>Error: {error}</div>;
  if (!profile) return <div>No profile data found.</div>;

  const userStatus = getStatusFromProfile(profile);
  console.log("USER STATUS ", userStatus);

  return (
    <div className="max-w-3xl mx-auto bg-white border border-gray-300 rounded-xl shadow-xl p-8">
      <UserHeader profile={profile} onLogout={handleLogout} />
      <StepsList steps={steps} userStatus={userStatus} />
    </div>
  );
};

export default UserDashboard;
